// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Utils = require("../../../utils/Utils.bs.js");
let React = require("react");
let IconV5 = require("../../../uikit/atoms/Icon/IconV5.bs.js");
let ButtonsV5 = require("../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
let HtmlHolder = require("../../../reason/common/HtmlHolder.bs.js");
let Text__Jsx3 = require("../../../uikit/reason/helpers/Text__Jsx3.bs.js");
let JsxRuntime = require("react/jsx-runtime");

function HtmlDisplayer(props) {
  let __proseStyle = props.proseStyle;
  let proseStyle = __proseStyle !== undefined ? __proseStyle : "sm";
  let match = React.useReducer((state, action) => {
    if (typeof action !== "object") {
      return {
        hasOverflow: state.hasOverflow,
        showingMore: !state.showingMore
      };
    } else {
      return {
        hasOverflow: action._0,
        showingMore: state.showingMore
      };
    }
  }, {
    hasOverflow: false,
    showingMore: false
  });
  let send = match[1];
  let state = match[0];
  let hasOverflowCallback = React.useCallback(hasOverflow => send({
    TAG: "SetHasOverflow",
    _0: hasOverflow
  }), [send]);
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx(Text__Jsx3.WithOverflowV5.make, {
        lineClamp: state.showingMore ? undefined : 5,
        hasOverflowCallback: hasOverflowCallback,
        children: JsxRuntime.jsx(HtmlHolder.make, {
          proseStyle: proseStyle,
          innerHtml: props.text
        })
      }),
      state.hasOverflow || state.showingMore ? JsxRuntime.jsx("div", {
          children: JsxRuntime.jsxs(ButtonsV5.LinkButton.make, {
            onClick: param => send("ToggleShowMore"),
            className: "flex gap-1 items-center",
            children: [
              JsxRuntime.jsx("span", {
                children: (
                  state.showingMore ? "Read Less" : "Read More"
                ) + Utils.$$String.nbsp,
                className: "text-lg"
              }),
              JsxRuntime.jsx(IconV5.make, {
                icon: state.showingMore ? "arrow-up" : "arrow-down",
                size: 14,
                className: "mt-[2px]"
              })
            ]
          }),
          className: "mt-[8px]"
        }) : null
    ]
  });
}

let View;

let make = HtmlDisplayer;

exports.View = View;
exports.make = make;
/* Utils Not a pure module */
